import TreatmentPlan from "./TreatmentPlan"

export default TreatmentPlan
